module.exports = __webpack_public_path__ + "static/media/6.c69f1cae.JPG";